export interface AddItemsError {
  message: string;
  records: Array<string>;
}

export interface AddItemsErrors {
  errors: Array<AddItemsError>;
  message: string;
}

export interface AddItemsResult extends AddItemsErrors {
  responseIDs: Array<string>;
}

export interface BaseSchool {
  schoolID: string;
  schoolName: string;
}

export interface BaseUser {
  avatar: string;
  email: string;
  firstName: string;
  lastName: string;
  userID: number;
}

export type Days = number;

export type ISOString = string;

export type Minutes = number;

export type Seconds = number;

export type UUID = string;

export enum SortOrder {
  Asc = 'asc',
  Desc = 'desc',
}

export enum AndOrOperation {
  AND = 'AND',
  OR = 'OR',
}
